<div class="options-dialog">
  <header>
    <div class="header-left">
      <h2>Product Options</h2>
      <div class="breadcrumbs" *ngIf="levels.length > 0">
        <ng-container *ngFor="let lvl of levels; let i = index; let isLast = last">
          <span class="crumb" [class.link]="!isLast" (click)="goBack(i)">{{lvl.account?.name}}</span>
          <span *ngIf="!isLast" class="crumb-divider">&rsaquo;</span>
        </ng-container>
      </div>
    </div>
    <div class="header-right">
      <div class="close" (click)="close()"></div>
    </div>
  </header>

  <div *ngIf="level && level.errors.length > 0" class="error-bar">
    <div *ngFor="let error of level.errors" class="error">{{error}}</div>
  </div>

  <div *ngIf="loading" class="loading">Loading . . .</div>
  <div *ngIf="loadError" class="error-bar"><div class="error">{{loadError}}</div></div>

  <section *ngIf="!loading && level && level.account" class="body">

    <!-- Column 1: choice groups -->
    <aside class="groups-column">
      <div class="column-title">Choice Groups</div>

      <div *ngIf="level.groups.length === 0 && !level.addingGroup" class="empty-state">
        No choices yet. Add one to let customers customize this item, or to define its recipe.
      </div>

      <div cdkDropList class="group-card-list" (cdkDropListDropped)="dropGroup($event)">
        <div *ngFor="let group of level.groups; let i = index" class="group-card" cdkDrag
             [class.active]="i === level.activeGroupIndex && !level.addingGroup"
             (click)="setActiveGroup(i)">
          <div class="group-card-type">{{typeLabel(group.type)}}</div>
          <div class="group-card-name">
            <ng-container *ngIf="group.type != 'components'">{{group.name || 'Unnamed'}}</ng-container>
            <ng-container *ngIf="group.type == 'components'">What this item is made of</ng-container>
          </div>
          <div class="group-card-summary">
            {{group.options.length}} {{group.options.length === 1 ? 'option' : 'options'}}
            <ng-container *ngIf="group.type == 'multiple' || group.type == 'multipleMultiple'">
              <ng-container *ngIf="group.min || group.max">
                &middot; pick {{group.min || 0}}<ng-container *ngIf="group.max"> to {{group.max}}</ng-container><ng-container *ngIf="!group.max">+</ng-container>
              </ng-container>
            </ng-container>
          </div>
          <div class="group-card-remove" title="Remove group" (click)="$event.stopPropagation(); removeGroup(i)">&times;</div>
        </div>
      </div>

      <div class="button green add-group-button" *ngIf="!level.addingGroup" (click)="startAddGroup()">+ Add Choice Group</div>

      <div *ngIf="level.addingGroup" class="type-picker">
        <div class="column-title">What kind of choice is this?</div>
        <div *ngFor="let groupType of groupTypes" class="type-card" (click)="addGroup(groupType.type)">
          <div class="type-card-label">{{groupType.label}}</div>
          <div class="type-card-example">{{groupType.example}}</div>
        </div>
        <div class="button cancel-add" (click)="level.addingGroup = false">Cancel</div>
      </div>
    </aside>

    <!-- Column 2: active group editor -->
    <main class="editor-column">
      <ng-container *ngIf="activeGroup as group; else noGroup">

        <div class="group-settings">
          <div *ngIf="group.type != 'components'" class="field">
            <label>Group Name <span class="hint">shown to the customer</span></label>
            <input type="text" [(ngModel)]="group.name" placeholder="e.g. Choose your meat" />
          </div>

          <div *ngIf="group.type == 'components'" class="recipe-note">
            Ingredients are always included, never shown at the register, and drive this item's
            cost and stock automatically. While a recipe exists, cost is calculated from the
            ingredients instead of being entered directly.
          </div>

          <div *ngIf="group.type == 'multiple' || group.type == 'multipleMultiple'" class="min-max-fields">
            <div class="field">
              <label>Minimum <span class="hint">0 = optional</span></label>
              <input type="number" min="0" [(ngModel)]="group.min" (ngModelChange)="groupChanged()" />
            </div>
            <div class="field">
              <label>Maximum <span class="hint">blank = no limit</span></label>
              <input type="number" min="0" [(ngModel)]="group.max" (ngModelChange)="groupChanged()" />
            </div>
          </div>

          <div class="field type-change">
            <label>Choice Type</label>
            <select [(ngModel)]="group.type" (ngModelChange)="groupChanged()">
              <option *ngFor="let groupType of groupTypes" [value]="groupType.type">{{groupType.label}}</option>
            </select>
          </div>
        </div>

        <div class="options-list">
          <div cdkDropList class="option-row-list" (cdkDropListDropped)="dropOption($event)">
          <div *ngFor="let option of group.options; let i = index" class="option-row" cdkDrag>
            <div class="option-header">
              <div class="drag-handle" cdkDragHandle title="Drag to reorder">&#8942;&#8942;</div>
              <div class="option-item">
                <span class="option-item-name">{{childAccount(option)?.name || option.name}}</span>
                <span *ngIf="childAccount(option)?.unitDescription" class="option-item-detail">{{childAccount(option)?.unitDescription}}</span>
              </div>
              <div class="option-buttons">
                <div class="icon-text-button" title="Open this item" (click)="openItem(option)">Open &rsaquo;</div>
                <div class="icon-text-button remove" title="Remove option" (click)="removeOption(i)">&times;</div>
              </div>
            </div>

            <div class="option-controls">
              <div *ngIf="group.type != 'components'" class="field">
                <label>Display Name</label>
                <input type="text" [(ngModel)]="option.name" />
              </div>

              <div *ngIf="group.type != 'components' && level.account.subtype != 'selector'" class="field price-field" [class.warning]="priceBelowCost(option)">
                <label>Extra Charge $ <span class="hint">blank = free</span></label>
                <input type="number" step="0.25" min="0" [(ngModel)]="option.price" />
                <div *ngIf="priceBelowCost(option)" class="price-warning">Below estimated cost</div>
              </div>

              <div *ngIf="group.type != 'components' && group.type != 'multipleMultiple'" class="field toggle-field">
                <label>Pre-selected</label>
                <app-toggle (valueChanged)="toggleDefault(option)" [checked]="option.default > 0"></app-toggle>
              </div>

              <div *ngIf="group.type == 'multipleMultiple'" class="field">
                <label>Pre-selected Qty</label>
                <input type="number" min="0" [(ngModel)]="option.default" (ngModelChange)="resetPreview()" />
              </div>

              <div *ngIf="group.type == 'components'" class="field qty-field">
                <label>Amount Used</label>
                <div class="qty-input">
                  <input type="number" min="0" step="any" [(ngModel)]="option.qty" />
                  <span class="unit">{{childAccount(option)?.unitOfMeasure}}</span>
                </div>
              </div>
            </div>

            <div *ngIf="level.showAdvanced" class="option-advanced">
              <div *ngIf="group.type != 'components'" class="field qty-field">
                <label>Stock Used Per Pick</label>
                <div class="qty-input">
                  <input type="number" min="0" step="any" [(ngModel)]="option.qty" />
                  <span class="unit">{{childAccount(option)?.unitOfMeasure}}</span>
                </div>
              </div>
              <div class="advanced-cost">
                Est. cost:
                <ng-container *ngIf="optionCostRange(option).low == optionCostRange(option).high">
                  {{optionCostRange(option).high | rf:'currencyDetail'}}
                </ng-container>
                <ng-container *ngIf="optionCostRange(option).low != optionCostRange(option).high">
                  {{optionCostRange(option).low | rf:'currencyDetail'}} &ndash; {{optionCostRange(option).high | rf:'currencyDetail'}}
                </ng-container>
              </div>
            </div>
          </div>

          </div>

          <div *ngIf="group.options.length === 0" class="empty-state">
            <ng-container *ngIf="group.type == 'components'">Search below to add the items this is made of.</ng-container>
            <ng-container *ngIf="group.type != 'components'">Search below to add the choices the customer can pick from.</ng-container>
          </div>

          <div class="field add-option-field">
            <label>Add an item <span class="hint">search, or type a new name to create it</span></label>
            <app-dropdown [(optionGroup)]="itemSearchField"
              placeholder="Find / Add"
              [enableAddNew]="true"
              (optionGroupChange)="itemSelected()"
              (searchChanged)="searchItems($event)"
              (newSelected)="createNewItem($event)">
            </app-dropdown>
          </div>
        </div>

        <div class="editor-footer">
          <div class="advanced-toggle" (click)="level.showAdvanced = !level.showAdvanced">
            {{level.showAdvanced ? 'Hide' : 'Show'}} advanced (stock &amp; cost)
          </div>
          <div *ngIf="level.showAdvanced" class="group-cost">
            Group est. cost:
            <ng-container *ngIf="groupCostRange(group).low == groupCostRange(group).high">
              {{groupCostRange(group).high | rf:'currencyDetail'}}
            </ng-container>
            <ng-container *ngIf="groupCostRange(group).low != groupCostRange(group).high">
              {{groupCostRange(group).low | rf:'currencyDetail'}} &ndash; {{groupCostRange(group).high | rf:'currencyDetail'}}
            </ng-container>
          </div>
        </div>

      </ng-container>
      <ng-template #noGroup>
        <div class="empty-state" *ngIf="!level.addingGroup">
          Select a choice group on the left, or add one to get started.
        </div>
        <div class="empty-state" *ngIf="level.addingGroup">
          Pick what kind of choice to add on the left.
        </div>
      </ng-template>
    </main>

    <!-- Column 3: register preview -->
    <aside class="preview-column">
      <div class="column-title">Register Preview</div>
      <ng-container *ngIf="activeGroup as group">

        <div *ngIf="group.type == 'components'" class="preview-hidden-note">
          Recipe / Ingredient groups are never shown at the register. The cashier just sells
          "{{level.account.name}}" and the ingredients are deducted automatically.
        </div>

        <div *ngIf="group.type != 'components'" class="preview-device">
          <div class="preview-item-title">{{level.account.shortName || level.account.name}}</div>
          <div class="preview-group-name">
            {{group.name || 'Unnamed'}}
            <span *ngIf="group.max" class="preview-counter">( {{previewSelectedCount(group)}} / {{group.max}} )</span>
          </div>

          <div *ngFor="let option of group.options" class="preview-option"
               [class.selected]="previewQty(option) > 0"
               (click)="previewClick(group, option)">
            <div *ngIf="group.type == 'multipleMultiple'" class="preview-stepper" (click)="$event.stopPropagation()">
              <div class="step-button" (click)="previewStep(group, option, -1)">&minus;</div>
              <div class="step-button" [class.disabled]="!previewCanAdd(group)" (click)="previewStep(group, option, 1)">+</div>
            </div>
            <div class="preview-option-name">
              {{option.name || childAccount(option)?.name}}
              <span *ngIf="previewQty(option) > 1" class="preview-qty-badge">x{{previewQty(option)}}</span>
            </div>
            <div *ngIf="option.price" class="preview-option-price">+{{option.price * 100 | rf:'currency'}}</div>
          </div>

          <div *ngIf="group.min" class="preview-min-note">Customer must pick at least {{group.min}}.</div>
          <div class="preview-reset" (click)="resetPreview()">Reset preview</div>
        </div>

      </ng-container>
      <div *ngIf="!activeGroup" class="empty-state">
        The selected group will be previewed here exactly as the register shows it.
      </div>
    </aside>

  </section>

  <footer *ngIf="level && level.account">
    <div *ngIf="isDirty()" class="unsaved-note">Unsaved changes</div>
    <div class="button green" [class.disabled]="level.saving" (click)="save()">Save</div>
  </footer>
</div>
